import React, { Component } from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import { Helmet } from "react-helmet";
import Geosuggest from 'react-geosuggest';
import { Link, Redirect, Prompt } from 'react-router-dom';
import './Group.css';

import { ChangePictureIcon, BannerShimmer, LiveGames, PostItem, EmptyState,LoadingState, GlobalTMFeeds, GlobalTMForm, LeagueSplitView, ConfirmModal, ItemPicker, Modal, ComboBox, PhotoAddModal, TagView, MomentPickerModal, EditGameModal, PublicityPicker } from '.././components/Common';
import { EventViewCreateForm1, EventGroupChatCreate, LocationPicker, EventViewSplitPane } from '.././components/Event';
import Avatar from '.././components/Avatar';
import GroupEvents from '.././components/GroupEvents';
import GroupMembers from '.././components/GroupMembers';
import Photos from '.././components/Photos';
import Videos from '.././components/Videos';
import InternalNoticeCenter from '.././components/InternalNoticeCenter';

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;

export default class Group extends Component {
    constructor(props) {
        super(props);
        this.state = {
            group: { id: null, name: "Group", image: "", error: false },
            activeTab: 'timeline',
            tabs: [
                { val: "timeline", key: "Timeline", notices: [] },
                { val: "members", key: "Members", notices: [] },
                { val: "photos", key: "Photos", notices: [] },
                { val: "videos", key: "Videos", notices: [] },
                { val: "events", key: "Events", notices: [] },
                { val: "notice", key: "Notifications", notices: [] },
                { val: "about", key: "About", notices: [] }
            ],
            posts: [],
            isLoadingPosts:true,
            yourVideos: [],
            yourPhotos: [],
            events: [],
            albums: []
        }
    }

    componentWillMount() {
        const s = new Trojan.style("league").kill()
        FakeData.mountState("group", true)
    }

    componentDidMount() {
        const _that = this
        setTimeout(() => {
            _that.getProfile()
            _that.getPosts()
            _that.getEvents()
            _that.getYourPhotos()
            _that.getYourVideos()
            var params = FakeData.getQueries(_that.props.location.search);
            _that.setState({ activeTab: (params.sInit) ? params.sInit : "about" });
        }, 1000)

        //document.querySelector("#root").addEventListener('scroll', this.onScroll);

        //console.log(this.props)
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.match.params.id !== nextProps.match.params.id || this.props.location.search !== nextProps.location.search) {
            const _that = this
            FakeData.mountState("group", false)
            this.setState({
                user: { id: null }
            });
            const s = new Trojan.style("league").kill()

            setTimeout((() => {
                FakeData.mountState("group", true)
                _that.getProfile()
                //_that.getPosts()
                _that.getEvents()
                _that.getYourPhotos()
                _that.getYourVideos()
                var params = FakeData.getQueries(nextProps.location.search);
                _that.setState({ activeTab: (params.sInit) ? params.sInit : "about" });
            }), 1000)

            return true;
        }

        if (this.props.location.search !== nextProps.location.search) {
            var params = FakeData.getQueries(nextProps.location.search);
            this.setState({ activeTab: params.sInit });
        }

        return true
    }

    componentWillUnmount() {
        FakeData.mountState("group", false)
        //window.removeEventListener('scroll', this.onScroll);
        //document.querySelector("#root").removeEventListener('scroll', this.onScroll);
    }

    getProfile = () => {
        const _that = this
        const dataTo = {
            userId: FakeData.getData('yoo').id,
            groupId: this.props.match.params.id
        }

        FakeData.post("/getGroupForum.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("group")) {
                    return
                }

                _that.state.tabs[6].notices = _that.getUnreadNotices(res.notices);
                _that.state.tabs[1].notices = res.requests;
                _that.setState({
                    group: res,
                    tabs: _that.state.tabs
                });
                setTimeout((() => {
                    _that.getProfile()
                }), 5000)
            }),
            error: ((err) => {

            })
        })
    }

    getUnreadNotices = (notices) => {
        const list = []
        FakeData.listify(notices).forEach((item, i) => {
            if (item.context.status === "unread") {
                list.push(item)
            }
        })

        return list;
    }

    getPosts = () => {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.group.id,
                type: "Q"
            },
            clubs: [],
            leagues: [],
            teams: [],
            limit: this.state.limit
        }

        FakeData.post("/getPosts.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("group")) {
                    return
                }
                _that.setState({
                    posts: res,
                    isLoadingPosts:false
                })

                setTimeout((() => {
                    //_that.getPosts()
                }), 10000)
            }),
            error: ((err) => {
                
            })
        })
    }

    getYourPhotos = () => {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.group.id,
                type: "Q",
            }
        }

        FakeData.post("/getPhotos.php?auth0&yours", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("group")) {
                    return
                }

                //console.log(res)
                _that.setState({
                    yourPhotos: res
                })

                FakeData.setData("group_photos", res)

                setTimeout((() => {
                    _that.getYourPhotos()
                }), 10000)
            }),
            error: ((res) => {
                
            })
        })
    }

    getYourVideos = () => {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.group.id,
                type: "Q",
            }
        }

        FakeData.post("/getVideos.php?auth0&yours", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("group")) {
                    return
                }
                _that.setState({
                    yourVideos: res
                })

                FakeData.setData("group_vids", res)

                setTimeout((() => {
                    _that.getYourVideos()
                }), 10000)
            }),
            error: ((res) => {
                
            })
        })
    }

    getEvents = () => {
        const _that = this
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            userToId: this.state.group.id,
            userToType: "Q",
            teamIds: []
        }

        FakeData.post("/getEvents.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("group")) {
                    return
                }
                res.sort(function (a, b) {
                    return b.timestamp - a.timestamp
                })

                _that.setState({
                    events: res
                })

                setTimeout((() => {
                    _that.getEvents()
                }), 10000)
            }),
            error: ((err) => {
                
            })
        })
    }

    onTabChanged = (tab) => {
        this.setState({ activeTab: tab.val });
    }

    onPostAdded = (post) => {
        //console.log(this.state.posts.length);
        this.state.posts.unshift(post)
        this.setState({
            posts: this.state.posts
        });
    }

    render = () => {
        const { tabs, group, activeTab, posts, yourPhotos, yourVideos, albums, events, isLoadingPosts } = this.state
        if (group.error) {
            return (
                <Redirect to={{ pathname: "/404", state: null }} />
            )
        }

        if (group.id === null) {
            return (
                <BannerShimmer />
            );
        }

        return (
            <div className="group-profile" style={{ width: "80vw" }}>
                <GroupSideView tabs={tabs} activeTab={activeTab} events={events} profile={group} onTabChanged={this.onTabChanged.bind(this)} posts={posts} videos={yourVideos} photos={yourPhotos} />
                <GroupMainView tabs={tabs} isLoadingPosts={isLoadingPosts} activeTab={activeTab} events={events} videos={yourVideos} photos={yourPhotos} albums={albums} onTabChanged={this.onTabChanged.bind(this)} profile={group} posts={posts} onPostAdded={this.onPostAdded.bind(this)} />
            </div>
        )
    }
}

class GroupSideView extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            value: this.props.profile.name,
            isEditting: false,
            privacy: this.props.profile.privacy_value
        }

        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange = (e) => {
        const value = e.target.value;
        this.setState({ value });
    }

    save = () => {
        const { isEditting, value, privacy } = this.state;
        const { profile } = this.props;
        //updateAboutData.php?auth0&ref=group_forum&q=ID
        const _that = this;
        if (value.length < 3) {
            FakeData.alert("Group name can not be less than 3 characters!");
            return;
        }

        const url = "/updateTable.php?auth0&ref=group_forum";

        const data = {
            data: { Name: value, Privacy: privacy },
            query: "ID='" + profile.id + "'",
            user: { id: FakeData.getData("yoo").id, type: "F" },
            userTo: { id: profile.id, type: "Q" }
        }

        FakeData.post(url, data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Coundn't update data!");
                } else {
                    _that.setState({
                        isEditting: false,
                        value: ""
                    });
                }
            },
            error(err) {
                FakeData.alert("Coundn't update data!");
                //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
            }
        }, true, "", (t) => { })
    }

    render = () => {
        const { tabs, activeTab, profile, onTabChanged, posts, photos, videos, events } = this.props;
        const { isEditting, value, privacy } = this.state;
        return (
            <div className="group-side-view">
                <div className="group-side-view-header">
                    <div className="group-side-view-header-1" style={{ background: "#374353", color: FakeData.getLuminance("#374353"), position: "relative" }}>
                        {!isEditting && <span>{profile.name}</span>}
                        {!isEditting && <span>{profile.privacy}</span>}
                        {(!isEditting && profile.isAdmin) && <i className="material-icons" onClick={() => this.setState({ isEditting: true })} style={{ fontSize: "13px", position: "absolute", top: 0, right: 0, marginRight: "16px", marginTop: "16px" }}>edit</i>}
                        {(isEditting && profile.isAdmin) &&
                            <div className="group-side-basic-edit">
                                <input value={value} placeholder={profile.name} className={value.length < 3 ? "error" : ""} onChange={this.onValueChange} />
                                <PublicityPicker style={{ justifyContent: "flex-start", color: "#fff" }}
                                    tags={[
                                        { key: 1, icon: "public", name: "Public" },
                                        { key: 0, icon: "lock", name: "Closed" },
                                        { key: 2, icon: "lock", name: "Secret" }
                                    ]}
                                    onChange={(e) => {
                                        const _that = this
                                        _that.setState({ privacy: e });
                                    }} />
                                <button onClick={this.save.bind(this)}>Save</button>
                            </div>
                        }
                        {(isEditting && profile.isAdmin) && <i className="material-icons" onClick={() => this.setState({ isEditting: false })} style={{ fontSize: "13px", position: "absolute", top: 0, right: 0, marginRight: "16px", marginTop: "16px" }}>close</i>}
                    </div>
                    <div className="group-side-view-header-2">
                        <div>
                            <span>Posts</span>
                            <span>{FakeData.shortDigit(posts.length).text}</span>
                        </div>
                        <div>
                            <span>Members</span>
                            <span>{FakeData.shortDigit(profile.members.length).text}</span>
                        </div>
                        <div>
                            <span>Media</span>
                            <span>{FakeData.shortDigit((photos.length + videos.length)).text}</span>
                        </div>
                    </div>
                </div>
                <div className="group-side-view-content">
                    {
                        FakeData.listify(tabs).map((item, i) => {
                            return (
                                <div className={activeTab === item.val ? "active" : ""} key={item.key} onClick={() => onTabChanged(item)}>
                                    {item.key}
                                    {item.notices.length > 0 &&
                                        <span className="alert-bg">
                                            {item.notices.length}
                                        </span>
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

class GroupMainView extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isEdittingDesc: false,
            bioLimit: 150,
            newTag: "",
            newLoc: this.props.profile.location,
            tags: this.props.profile.tags,
            aboutText: this.props.profile.about.replace(/<br[^>]*>/g, "\n"),
            isEdittingTags: false,
            isEdittingLoc: false,
            activeAbout: "Overview"
        }
    }

    saveAbout = () => {
        const _that = this;
        const { tabs, activeTab, profile, posts, onPostAdded, videos, photos, albums } = this.props;
        const { isEdittingDesc, bioLimit, aboutText } = this.state;

        if (aboutText.length < 3) {
            FakeData.alert("Group description can not be less than 4 characters!");
            return;
        }

        const url = "/updateTable.php?auth0&ref=group_forum";

        const data = {
            data: { Description: aboutText.replace(/\r?\n/g, '<br/>') },
            query: "ID='" + profile.id + "'",
            user: { id: FakeData.getData("yoo").id, type: "F" },
            userTo: { id: profile.id, type: "Q" }
        }

        FakeData.post(url, data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Coundn't update data!");
                } else {
                    _that.setState({ isEdittingDesc: false, bioLimit: aboutText.length });
                }
            },
            error(err) {
                FakeData.alert("Coundn't update data!");
                //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
            }
        }, true, "", (t) => { })
    }

    saveTags = () => {
        const _that = this;
        const { tabs, activeTab, profile, posts, onPostAdded, videos, photos, albums } = this.props;
        const { tags } = this.state;

        if (tags.length > 6) {
            FakeData.alert("Group tags can not be more than 6!");
            return;
        }

        const url = "/updateTable.php?auth0&ref=group_forum";

        const data = {
            data: { Tags: FakeData.listify(tags).join(",") },
            query: "ID='" + profile.id + "'",
            user: { id: FakeData.getData("yoo").id, type: "F" },
            userTo: { id: profile.id, type: "Q" }
        }

        FakeData.post(url, data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Coundn't update data!");
                } else {
                    FakeData.alert("Saved!");
                    _that.setState({ isEdittingTags: false });
                }
            },
            error(err) {
                FakeData.alert("Coundn't update data!");
                //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
            }
        }, true, "", (t) => { })
    }

    saveLoc = () => {
        const _that = this;
        const { tabs, activeTab, profile, posts, onPostAdded, videos, photos, albums } = this.props;
        const { newLoc } = this.state;

        if (newLoc.length < 6) {
            FakeData.alert("Invalid location");
            return;
        }

        const url = "/updateTable.php?auth0&ref=group_forum";

        const data = {
            data: { Location: newLoc },
            query: "ID='" + profile.id + "'",
            user: { id: FakeData.getData("yoo").id, type: "F" },
            userTo: { id: profile.id, type: "Q" }
        }

        FakeData.post(url, data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Coundn't update data!");
                } else {
                    FakeData.alert("Saved!");
                    _that.setState({ isEdittingLoc: false });
                }
            },
            error(err) {
                FakeData.alert("Coundn't update data!");
                //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
            }
        }, true, "", (t) => { })
    }

    inSelection = (user, users) => {
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    getFriendsToAdd = () => {
        const list = [];
        const { tabs, activeTab, profile, posts, onPostAdded, videos, photos, albums } = this.props;

        FakeData.listify(FakeData.getData("yoo").friends).forEach((item, i) => {
            if (!this.inSelection(item, profile.members)) {
                list.push(item)
            }
        })

        return list;
    }

    render = () => {
        const { tabs, activeTab, profile, posts, onPostAdded, videos, photos, albums, events } = this.props;
        const { isEdittingDesc, bioLimit, aboutText, tags, isEdittingTags, newTag, newLoc, isEdittingLoc, activeAbout } = this.state;

        return (
            <div className="group-main-view">
                <GroupBanner BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={profile} photos={photos} />
                <GroupContent>
                    {activeTab === "timeline" &&
                        <div className="group-main-view-timeline">
                            <div className="group-main-view-timeline-1">
                                <GlobalTMForm BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={profile} direct={true} withoutCheckIn={true} label={"Share"} style={{ marginTop: 0, marginBottom: "10px" }} user={FakeData.getData("yoo")} userType={"F"} isAdmin={false} onPostAdded={onPostAdded} postToType="Q" postToId={profile.id} postToName={profile.name} postToImage={profile.image} />
                                <GlobalTMFeeds BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} page={{
                                id:profile.id,
                                type: "Q"
                            }}  profile={profile} hideSportLabel={true} styles={{ normalPosts: { marginBottom: "10px" }, gmcPosts: { marginBottom: "10px" } }} user={FakeData.getData("yoo")} userType={"F"} posts={posts}>
                                    <EmptyState style={{ background: "#fff" }} isShown={(FakeData.listify(posts).length === 0 && !this.props.isLoadingPosts) ? true : false} text="No posts were found!" icon="filter_hdr" />
                                    <LoadingState style={{ background: "#fff" }} isShown={this.props.isLoadingPosts} text={"Loading"}/>
                                </GlobalTMFeeds>
                            </div>
                            <div className="group-main-view-timeline-2">
                                {this.is &&
                                    <div className="group-field-lbl">
                                        <span style={{ position: "relative" }}>
                                            <span>Members</span>
                                            <SeeMore onClick={() => {
                                                this.props.onTabChanged({ val: "members", key: "Members", notices: [] });
                                            }} />
                                        </span>
                                        <div style={{ fontSize: "13px" }}>
                                            <div className="group-members-list">
                                                {
                                                    FakeData.listify(profile.members).map((item, i) => {
                                                        if (i > 4) {
                                                            return null;
                                                        }
                                                        return (
                                                            <div key={i}>
                                                                <img src={item.image} />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                {//(profile.isMember && this.getFriendsToAdd().length > 0) && <div style={{ margin: "5px 2%", width: "96%", background: "#aaa", height: "1px" }} />
                                }
                                {(profile.isMember && this.getFriendsToAdd().length > 0) &&
                                    <GroupFieldLabel label="Add Members">
                                        <AddGroupMemberMini group={profile} users={profile.members} />
                                    </GroupFieldLabel>
                                }
                                {(profile.isMember && this.getFriendsToAdd().length > 0) &&
                                    <div style={{ margin: "5px 2%", width: "96%", background: "#aaa", height: "1px" }} />
                                }
                                {this.is &&
                                    <div className="group-field-lbl">
                                        <span style={{ position: "relative" }}>
                                            <span>Description</span>
                                            <EditDesc isAdmin={profile.isAdmin} isEdittingDesc={isEdittingDesc} onClick={() => {
                                                this.setState({ isEdittingDesc: !isEdittingDesc });
                                            }} />
                                        </span>
                                        <div style={{ fontSize: "13px" }}>
                                            {!isEdittingDesc && <span dangerouslySetInnerHTML={{ __html: profile.about.substring(0, bioLimit) }} />}
                                            {!isEdittingDesc && (bioLimit === 150 && profile.about.length > 151) && "..."}
                                            {(!isEdittingDesc && profile.about.length > 151) &&
                                                <span style={{ display: "block", marginTop: "5px", fontSize: "12px", color: "#4ac", cursor: "pointer" }} onClick={() => {
                                                    const val = bioLimit === 150 ? profile.about.length : 150;
                                                    this.setState((state, props) => { return { bioLimit: val } });

                                                }}>View {bioLimit > 150 ? "Less" : "More"}</span>
                                            }
                                            {isEdittingDesc &&
                                                <textarea style={{ width: "100%", height: 150 }} value={aboutText} placeholder={profile.about} onChange={(e) => {
                                                    this.setState({ aboutText: e.target.value });
                                                }} />
                                            }
                                            {isEdittingDesc &&
                                                <button onClick={this.saveAbout.bind(this)} style={{ lineHeight: "30px" }} className="button">Save</button>
                                            }
                                        </div>
                                    </div>
                                }

                                <div className="group-field-lbl">
                                    <span style={{ position: "relative" }}>
                                        <span>Tags</span>
                                        {profile.isAdmin &&
                                            <SeeMore label={isEdittingTags ? "Cancel" : "Edit"} onClick={() => {
                                                this.setState((state, props) => { return { isEdittingTags: !state.isEdittingTags } });
                                            }} />
                                        }
                                    </span>
                                    <div style={{ fontSize: "13px" }}>
                                        <div className="group-tag-list">
                                            {isEdittingTags &&
                                                tags.map((item, i) => {
                                                    return (
                                                        <span className={isEdittingTags ? "group-tag-item edit" : "group-tag-item"} key={item + i}>
                                                            {item}
                                                            {isEdittingTags &&
                                                                <i className="material-icons" onClick={() => {
                                                                    tags.splice(i, 1);
                                                                    this.setState((state, props) => { return { tags } });
                                                                }}>close</i>
                                                            }
                                                        </span>
                                                    )
                                                })
                                            }
                                            {!isEdittingTags &&
                                                profile.tags.map((item, i) => {
                                                    return (
                                                        <span className={isEdittingTags ? "group-tag-item edit" : "group-tag-item"} key={item + i}>
                                                            {item}
                                                            {isEdittingTags &&
                                                                <i className="material-icons" onClick={() => {
                                                                    tags.splice(i, 1);
                                                                    this.setState((state, props) => { return { tags } });
                                                                }}>close</i>
                                                            }
                                                        </span>
                                                    )
                                                })
                                            }
                                            {(isEdittingTags && tags.length === 0) &&
                                                <span>Enter a tag name below</span>
                                            }
                                            {(!isEdittingTags && profile.tags.length === 0) &&
                                                <span>No tags</span>
                                            }
                                            {isEdittingTags &&
                                                <input
                                                    className=""
                                                    value={newTag}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        this.setState((state, props) => { return { newTag: val } });
                                                    }}
                                                    onKeyPress={(e) => FakeData.onKeyPress(e)}
                                                    onKeyDown={(e) => {
                                                        if ((e.keyCode === 13 || e.which === 13)) {
                                                            e.preventDefault()
                                                            const val = e.target.value;
                                                            tags.push(val);
                                                            this.setState((state, props) => ({ tags, newTag: "" }));
                                                        }
                                                    }} />
                                            }
                                        </div>
                                        {isEdittingTags &&
                                            <button onClick={this.saveTags.bind(this)} style={{ lineHeight: "30px" }} className="button">Save</button>
                                        }
                                    </div>
                                </div>
                                <div style={{ margin: "5px 2%", width: "96%", background: "#aaa", height: "1px" }} />
                                <div className="group-field-lbl">
                                    <span style={{ position: "relative" }}>
                                        <span>Location</span>
                                        {profile.isAdmin &&
                                            <SeeMore label={isEdittingLoc ? "Cancel" : "Edit"} onClick={() => {
                                                this.setState((state, props) => { return { isEdittingLoc: !state.isEdittingLoc } });
                                            }} />
                                        }
                                    </span>
                                    <div style={{ fontSize: "13px" }}>
                                        {profile.location === "" ? "No location set" : profile.location}
                                        {isEdittingLoc &&
                                            <Geosuggest ref={"placeElem"} highlightMatch={true} onSuggestSelect={(item) => {
                                                const val = item.label
                                                this.setState({ newLoc: val });
                                                this.refs.placeElem.blur()
                                            }} />
                                        }
                                        {isEdittingLoc &&
                                            <button onClick={this.saveLoc.bind(this)} style={{ lineHeight: "30px" }} className="button">Save</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {activeTab == "events" &&
                        <GroupEvents profile={profile} isAdmin={profile.isAdmin} users={profile.members} events={events} />
                    }

                    {activeTab === "members" &&
                        <GroupMembers profile={profile} isAdmin={profile.isAdmin} users={profile.members} />
                    }
                    {activeTab == "videos" &&
                        <Videos user={profile} userType={"Q"} author={profile.name} data={{ uploads: videos, tagged: [] }} isAdmin={profile.isAdmin} />
                    }
                    {activeTab == "photos" &&
                        <Photos user={profile} userType={"Q"} author={profile.name} data={{ uploads: photos, tagged: [], albums: albums }} isAdmin={profile.isAdmin} />
                    }
                    {activeTab == "notice" &&
                        <InternalNoticeCenter hideSettingBtn={true} notices={profile.notices} profile={profile} type={"Q"} />
                    }
                    {(activeTab == "about" && profile.isAdmin) &&
                        <div style={{ background: "#fff" }}>
                            <EventViewSplitPane isExtended={false} active={activeAbout} items={["Admin Activity", "Overview"]} setView={(d) => {
                                this.setState({
                                    activeAbout: d
                                });
                            }}>
                                {activeAbout === "Admin Activity" &&
                                    <ActivityLog logs={profile.log} />
                                }
                                {activeAbout === "Overview" &&
                                    <GroupAbout group={profile} />
                                }
                            </EventViewSplitPane>
                        </div>
                    }
                </GroupContent>
            </div>
        );
    }
}

const EditDesc = (props) => {
    if (!props.isAdmin) {
        return null;
    }
    return (
        <i className="material-icons" style={{ fontSize: "11px", color: "#4ac", position: "absolute", cursor: "pointer", right: 0, marginTop: "2px", marginRight: "8px" }} onClick={props.onClick}>
            {props.isEdittingDesc ? "close" : "edit"}
        </i>
    )
}

const SeeMore = (props) => {
    return (
        <span style={{ fontSize: "11px", color: "#4ac", position: "absolute", cursor: "pointer", right: 0, marginTop: "2px", marginRight: "8px" }} onClick={props.onClick}>
            {props.label ? props.label : "See All"}
        </span>
    )
}

class GroupBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLeaving: false,
            isRemoving: false,
            isEdittingSlogan: false,
            slogan: ""
        }

        this.onSloganChange = this.onSloganChange.bind(this);
    }

    onSloganChange = (e) => {
        this.setState({ slogan: e.target.value });
    }

    getDummy = (_num) => {
        const list = [];
        for (var index = 0; index < _num; index++) {
            list.push({ text: index })
        }

        return list;
    }

    getRandomColor(_num) {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(_num * 16)];
        }
        return color;
    }

    join = () => {
        const { profile } = this.props;
        const _that = this;
        const users = FakeData.listify(profile.members);

        const admins = FakeData.listify(profile.members).filter((item) => {
            return item.role === "admin";
        });

        const data = {
            userId: FakeData.getData("yoo").id,
            userType: "F",
            users,
            admins,
            group: profile
        }
        //joinGroup

        //console.log(data)
        FakeData.post("/joinGroup.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't finish request! Try again later!")
                } else {
                    FakeData.alert("Done!")
                }
            },
            error(err) {
                FakeData.alert("Couldn't finish request! Try again later!")
            }
        }, true, "", (r) => { })
    }

    leave = () => {
        const { profile } = this.props
        const users = FakeData.listify(profile.members).filter((item) => {
            return item.id === FakeData.getData("yoo").id;
        });

        const admins = FakeData.listify(profile.members).filter((item) => {
            return item.role === "admin";
        });

        const user = users[0];

        if (user.role === "admin" && admins.length === 1) {
            FakeData.alert("Can not remove the last admin of this group, try adding more!");
            this.setState({
                isLeaving: false
            })
            return;
        }

        const _that = this;

        const data = {
            userId: user.id,
            userType: user.type,
            memberId: user.memberId,
            groupId: profile.id,
            role: user.role
        }

        //console.log(data)
        FakeData.post("/removeMember.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't remove member from group! Try again later!")
                    _that.setState({
                        isLeaving: false
                    })
                } else {
                    FakeData.alert("Member was successfully removed from this group!")
                    _that.setState({
                        isLeaving: false
                    })
                }
            },
            error(err) {
                FakeData.alert("Couldn't remove member from group! Try again later!")
                _that.setState({
                    isLeaving: false
                })
            }
        }, true, "", (r) => { })
    }

    cancel = () => {
        const { profile } = this.props
        const users = FakeData.listify(profile.requests).filter((item) => {
            return item.id === FakeData.getData("yoo").id;
        });

        const user = users[0];

        const _that = this;

        const data = {
            userId: user.id,
            userType: user.type,
            joinId: user.joinId,
            groupId: profile.id,
        }

        //console.log(data)
        FakeData.post("/removeGroupForumRequest.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't remove request! Try again later!")
                    _that.setState({
                        isRemoving: false
                    })
                } else {
                    //FakeData.alert("Member was successfully removed from this group!")
                    _that.setState({
                        isRemoving: false
                    })
                }
            },
            error(err) {
                FakeData.alert("Couldn't remove request! Try again later!")
                _that.setState({
                    isRemoving: false
                })
            }
        }, true, "", (r) => { })
    }

    addToShortcuts = () => {
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            contentType: "Q",
            contentId: this.props.profile.id,
            contentName: this.props.profile.name,
            contentRef: this.props.profile.user,
            contentSearch: "?sInit=about",
            userType: "F"
        }

        const _that = this

        FakeData.post('/createShortcut.php?auth0', dataTo, {
            success: ((res) => {
                FakeData.alert("Done!");
            }),
            error: ((err) => {

            })
        }, true, "", () => { })
    }

    getMembership = () => {
        const { profile } = this.props
        const users = FakeData.listify(profile.members).filter((item) => {
            return item.id === FakeData.getData("yoo").id;
        });

        const user = users[0];
        return user;
    }

    updateNotice = (notice, value, id) => {
        const _this = this;
        const data = {
            id,
            notice,
            value
        }

        //console.log(data)
        FakeData.post("/updateGroupNotice.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't update settings! Try again later!")
                    _this.refs['notice'].blur()
                } else {
                    FakeData.alert("Done!")
                    _this.refs['notice'].blur()
                }
            },
            error(err) {
                FakeData.alert("Couldn't update settings! Try again later!")
                _this.refs['notice'].blur()
            }
        }, true, "", (r) => { })
    }

    saveSlogan = () => {
        const { isLeaving, isRemoving, isEdittingSlogan, slogan } = this.state;
        const { profile, photos } = this.props;
        //updateAboutData.php?auth0&ref=group_forum&q=ID
        const _that = this;
        if (slogan.length > 150) {
            FakeData.alert("Slogan can not be long the 150 characters");
            return;
        }

        const url = "/updateTable.php?auth0&ref=group_forum";

        const data = {
            data: { Slogan: slogan },
            query: "ID='" + profile.id + "'",
            user: { id: FakeData.getData("yoo").id, type: "F" },
            userTo: { id: profile.id, type: "Q" }
        }

        FakeData.post(url, data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Coundn't update data!");
                } else {
                    _that.setState({ isEdittingSlogan: false });
                }
            },
            error(err) {
                FakeData.alert("Coundn't update data!");
                //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
            }
        }, true, "", (t) => { })
    }

    render = () => {
        const { profile, photos } = this.props;
        const { isLeaving, isRemoving, isEdittingSlogan, slogan } = this.state;
        //const arr = new Array(40);
        const members = FakeData.listify(profile.members);
        return (
            <div className="group-banner" style={{ width: "100%", height: "30vw", background: "#555" }}>
                <div className="group-banner-head">
                    {profile.isAdmin &&
                        <div style={{
                            position: "absolute",
                            zIndex: 3,
                            fontSize: "13px",
                            color: "#fff",
                            padding: "10px"
                        }} className="group-banner-content-floating-acts">
                            <ChangePictureIcon propKey={"id"} toType="P" pictures={photos} type="CoverPicture" idField={"ID"} table={"group_forum"} field={"CoverPicture"} page="group_forum" toId={profile.id} pictureForType="Q" />
                        </div>
                    }
                    <img src={profile.image} />
                    <div className="group-banner-content">

                    </div>
                    <div className="group-banner-content" style={{ height: "10vw" }}>
                        {(profile.slogan !== "" && !profile.isAdmin) &&
                            <div className="floating-group-desc">
                                <div style={{ background: "#374353", color: FakeData.getLuminance("#374353"), width: "20vw", height: "10vw" }}>
                                    <span>{profile.slogan !== "" ? profile.slogan : "Add Slogan"}</span>
                                </div>
                            </div>
                        }
                        {(profile.isAdmin) &&
                            <div className="floating-group-desc">
                                <div style={{ background: "#374353", color: FakeData.getLuminance("#374353"), width: "20vw", height: "10vw" }}>
                                    {!isEdittingSlogan &&
                                        <span>{profile.slogan !== "" ? profile.slogan : "Add Slogan"}</span>
                                    }
                                    {!isEdittingSlogan && <br />}
                                    {!isEdittingSlogan && <i className="material-icons" style={{ fontSize: "13px", marginLeft: "10px", cursor: "pointer" }} onClick={() => this.setState({ isEdittingSlogan: true })}>edit</i>}
                                    {isEdittingSlogan &&
                                        <div className="group-banner-add-slogan">
                                            <input value={slogan} placeholder={profile.slogan !== "" ? profile.slogan : "Add Slogan"} className={slogan.length > 150 ? "error" : ""} onChange={this.onSloganChange} />
                                            <i className="material-icons" style={{ fontSize: "13px", cursor: "pointer" }} onClick={this.saveSlogan.bind(this)}>save</i>
                                            <i className="material-icons" style={{ fontSize: "13px", cursor: "pointer" }} onClick={() => this.setState({ isEdittingSlogan: false })}>close</i>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        <div className="group-banner-user-list-holder">
                            <div className="group-banner-user-list">
                                {
                                    this.getDummy(9).map((item, i) => {
                                        var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                        return (
                                            <div key={i} style={{ background: hue }} className={"group-banner-photo-item"}>

                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="group-banner-user-list">
                                {
                                    this.getDummy(9).map((item, i) => {
                                        var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                        return (
                                            <div key={i} style={{ background: hue }} className={"group-banner-photo-item"}>
                                                {members[i] &&
                                                    <img src={members[i].image} />
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="action-buttons" style={{
                        position: "absolute",
                        left: 0,
                        bottom: 0,
                        marginLeft: "10px",
                        color: "#fff"
                    }}>
                        {(!this.props.profile.hasShortcut && this.props.profile.isAdmin) && <div onClick={this.addToShortcuts.bind(this)}><i className="material-icons">add</i>Add to shortcuts</div>}
                        {(!this.props.profile.isMember && !this.props.profile.inRequests) && <div onClick={this.join.bind(this)}><i className="material-icons">group_add</i>Join</div>}
                        {(!this.props.profile.isMember && this.props.profile.inRequests) &&
                            <div onClick={() => {
                                this.setState({
                                    isRemoving: true
                                })
                            }}>
                                <i className="material-icons">block</i>Cancel Request
                            </div>
                        }
                        {this.props.profile.isMember &&
                            <div onClick={() => {
                                this.setState({
                                    isLeaving: true
                                })
                            }}>
                                <i className="material-icons">block</i>Leave
                            </div>
                        }
                        {(this.props.profile.isMember && this.getMembership().noticeConfig) &&
                            <div className="inline-not-settings" ref="notice" tabIndex={0} onClick={() => { }}>
                                <i className="material-icons">settings</i>Notifications
                                <div className="inline-not-settings-content">
                                    <span className={this.getMembership().noticeConfig.general.value ? "active" : ""} onClick={() => this.updateNotice("general", "active", this.getMembership().noticeConfig.general.id)}>On</span>
                                    <span className={!this.getMembership().noticeConfig.general.value ? "active" : ""} onClick={() => this.updateNotice("general", "deactive", this.getMembership().noticeConfig.general.id)}>Off</span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="group-banner-head-content">
                    {
                        this.getDummy(6).map((item, i) => {
                            var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                            return (
                                <div key={i} style={{ background: hue }} className="group-banner-photo-item">
                                    {photos[i] &&
                                        <img src={photos[i].media[0].url} />
                                    }
                                </div>
                            )
                        })
                    }
                </div>
                {(isLeaving) &&
                    <ConfirmModal message="Are you sure you want to leave this group?<br/>" isOpen={isLeaving} data={""}
                        onOkay={(data) => {
                            this.leave()
                        }}
                        onCancel={() => {
                            this.setState({
                                isLeaving: false
                            })
                        }} />
                }
                {(isRemoving) &&
                    <ConfirmModal message="Are you sure you want to cancel request?<br/>" isOpen={isRemoving} data={""}
                        onOkay={(data) => {
                            this.cancel()
                        }}
                        onCancel={() => {
                            this.setState({
                                isRemoving: false
                            })
                        }} />
                }
            </div>
        );
    }
}

class GroupContent extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

        }
    }

    render = () => {
        return (
            <div className="group-content" style={{ width: "100%", minHeight: "100vh", marginTop: "0.5vw" }}>
                {this.props.children}
            </div>
        )
    }

}

class GroupFieldLabel extends Component {

    render = () => {
        const { rightObject } = this.props
        return (
            <div className="group-field-lbl">
                <span style={{ position: "relative" }}>
                    <span>{this.props.label}</span>
                </span>
                <div>{this.props.children}</div>
            </div>
        )
    }
}

class AddGroupMemberMini extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: ""
        }
    }

    onChange = (e) => {
        this.setState({ filter: e.target.value });
    }

    filterData = () => {
        const { filter } = this.state;
        const list = FakeData.listify(FakeData.getData("yoo").friends).filter((item) => {
            return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 && !this.inSelection(item, this.props.users);
        })

        return list;
    }

    add = (user) => {
        const { users, group } = this.props
        const _that = this;
        const data = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: user,
            group
        }

        //console.log(data)

        FakeData.post("/addGroupMember.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't add member to group! Try again later!")
                } else {
                    FakeData.alert("Member was successfully added to this group!")
                }
            },
            error(err) {
                FakeData.alert("Couldn't add member to group! Try again later!")
            }
        }, true, "", (r) => { })
    }

    inSelection = (user, users) => {
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    render = () => {
        const list = this.filterData();
        return (
            <div style={{ width: "100%" }}>
                <input style={{ width: "100%", padding: "2px", marginBottom: "5px" }} onChange={this.onChange.bind(this)} />
                <div className="group-members-add-list">
                    {
                        list.map((item, i) => {
                            return (
                                <div key={i}>
                                    <img src={item.image} />
                                    <span>{item.name}</span>
                                    <button onClick={() => this.add(item)}>Add</button>
                                </div>
                            )
                        })
                    }
                    <span></span>
                </div>
            </div>
        )
    }
}

export class ActivityLog extends Component {
    constructor(props) {
        super(props);

    }

    getDays = () => {
        const { logs } = this.props;
        const list = [];
        FakeData.listify(logs).forEach((item, i) => {
            if (!FakeData.inArray(item.day, list)) {
                list.push(item.day);
            }
        })

        return list;
    }

    getLogsForDay = (day) => {
        const { logs } = this.props;
        const list = FakeData.listify(logs).filter((item) => {
            return item.day === day;
        })

        return list;
    }

    get = (text = "", user) => {
        const _str = text.split(" ");
        const hashes = text.match(/#[\w]+(?=\s|$)/g);
        //console.log(text,user)
        _str.forEach((item, i) => {
            if (item.indexOf(user.user.trim()) > -1) {
                //const hasS = item.indexOf("\'")>-1?true:false;
                _str[i] = "<a href=\"/profile/" + user.user + "?sInit=about\">" + user.name.trim() + "</a>" + "\'s";
            } else if (FakeData.inArray(item, hashes)) {
                _str[i] = "<a href=\"/hash/" + item.replace("#", "") + "\">" + item + "</a>";
            } else {
                _str[i] = "<span>" + item + "</span>";
            }
        })

        return _str.join(" ");
    }

    getType = () => {

    }

    render = () => {
        return (
            <div className="group-activity-log-holder">
                {
                    this.getDays().map((item, i) => {
                        return (
                            <div key={item} className="group-activity-logs">
                                <div className="group-activity-logs-head">{item}</div>
                                <div className="group-activity-logs-list">
                                    {
                                        this.getLogsForDay(item).map((log, g) => {
                                            return (
                                                <div className="group-activity-logs-item" key={log.id}>
                                                    <img src={log.user.image} />
                                                    <div className="group-activity-logs-item-content">
                                                        <div>
                                                            <Link to={{ pathname: "/profile/" + log.user.user, search: "?sInit=about" }}>{log.user.name}</Link>
                                                            <span dangerouslySetInnerHTML={{ __html: this.get(log.msg, log.tagged) }}></span>
                                                        </div>
                                                        <span>{log.date}</span>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

}

class GroupAbout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            group: this.props.group,
            newTag: "",
            errors: {
                name: false,
                about: false
            }
        }
    }

    reset = () => {
        this.setState((state, props) => { return { group: this.props.group } });
        FakeData.alert("New changes were cleared!");
    }

    save = () => {
        const { group, newTag, errors } = this.state;
        const _group = this.props.group;
        const _that = this;
        if (group.name === "") {
            FakeData.alert("Group Name can't be blank!");
            errors.name = true;
            this.setState((state, props) => { return { errors } });
            return;
        }

        if (group.about === "") {
            FakeData.alert("Group description can't be blank!");
            errors.about = true;
            this.setState((state, props) => { return { errors } });
            return;
        }

        console.log("now saving!")
        const url = "/updateTable.php?auth0&ref=group_forum";

        const data = {
            data: {
                Name: group.name,
                Privacy: group.privacy_value,
                Description: group.about.replace(/\r?\n/g, '<br/>'),
                Location: group.location,
                Tags: group.tags.join(","),
                Approval: group.isApproval?0:1,
                Post: group.canMembersPost ? 1 : 0,
                PostApprove: group.postApproval ? 0 : 1
            },
            query: "ID='" + group.id + "'",
            user: { id: FakeData.getData("yoo").id, type: "F" },
            userTo: { id: group.id, type: "Q" }
        }

        FakeData.post(url, data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Coundn't update data!");
                } else {
                    FakeData.alert("Saved!");
                    _that.setState({
                        isEditting: false,
                        value: ""
                    });
                }
            },
            error(err) {
                FakeData.alert("Coundn't update data!");
                //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
            }
        }, true, "", (t) => { })
    }

    render = () => {
        const { group, newTag, errors } = this.state;
        return (
            <div className="group-about-pane">
                <GroupAboutField label={"Group Name"}>
                    <GroupAboutFieldInput>
                        <input value={group.name} className={errors.name ? "error" : ""} style={{ border: "0.3px solid #ccc!important", padding: "4px", width: "75%" }} onChange={(e) => {
                            const val = e.target.value;
                            group.name = val;
                            errors.name = false;
                            this.setState((state, props) => { return { group, errors } });
                        }} />
                    </GroupAboutFieldInput>
                </GroupAboutField>
                <GroupAboutField label={"Group Privacy"}>
                    <GroupAboutFieldInput>
                        <PublicityPicker style={{ justifyContent: "flex-start", color: "#000" }}
                            tags={[
                                { key: 1, icon: "public", name: "Public" },
                                { key: 0, icon: "lock", name: "Closed" },
                                { key: 2, icon: "lock", name: "Secret" }
                            ]}
                            onChange={(e) => {
                                const _that = this
                                group.privacy = e
                                group.privacy_value = e === "Public" ? 1 : e === "Closed" ? 0 : 2
                                _that.setState({ group });
                            }} />
                    </GroupAboutFieldInput>
                </GroupAboutField>
                <GroupAboutField label={"Description"}>
                    <GroupAboutFieldInput>
                        <textarea className={errors.about ? "error" : ""} value={group.about.replace(/<br[^>]*>/g, "\n")} style={{ border: "0.3px solid #ccc!important", padding: "2px", width: "75%", height: "400px", resize: "none" }} onChange={(e) => {
                            const val = e.target.value;
                            group.about = val.replace(/\r?\n/g, '<br/>');
                            errors.about = false;
                            this.setState((state, props) => { return { group, errors } });
                        }} />
                    </GroupAboutFieldInput>
                </GroupAboutField>
                <GroupAboutField label={"Tags"}>
                    <GroupAboutFieldInput warning={"Let people find this group more based on a search key or hashtag, optional"}>
                        <div className="group-tag-list">
                            {
                                group.tags.map((item, i) => {
                                    return (
                                        <span className={"group-tag-item edit"} key={item + i}>
                                            {item}
                                            <i className="material-icons" onClick={() => {
                                                group.tags.splice(i, 1);
                                                this.setState((state, props) => { return { group } });
                                            }}>close</i>
                                        </span>
                                    )
                                })
                            }
                            {group.tags.length === 0 &&
                                <span>Enter a tag name below</span>
                            }
                            <input
                                className=""
                                value={newTag}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    this.setState((state, props) => { return { newTag: val } });
                                }}
                                onKeyPress={(e) => FakeData.onKeyPress(e)}
                                onKeyDown={(e) => {
                                    if ((e.keyCode === 13 || e.which === 13)) {
                                        e.preventDefault()
                                        const val = e.target.value;
                                        group.tags.push(val);
                                        this.setState((state, props) => ({ group, newTag: "" }));
                                    }
                                }} />
                        </div>
                    </GroupAboutFieldInput>
                </GroupAboutField>
                <GroupAboutField label={"Location"}>
                    <span>{group.location}</span>
                    <Geosuggest ref={"placeElem"} highlightMatch={true} onSuggestSelect={(item) => {
                        const val = item.label
                        group.location = val.replace(/\r?\n/g, '<br/>');
                        errors.location = false;
                        this.setState((state, props) => { return { group, errors } });
                        this.refs.placeElem.blur()
                    }} />
                </GroupAboutField>
                <GroupAboutField label={"Membership Approval"}>
                    <select value={group.isApproval ? "1" : "0"} onChange={(e) => {
                        const val = e.target.value;
                        group.isApproval = val === "0" ? false : true;
                        this.setState((state, props) => { return { group } });

                    }}>
                        <option value="0">Admin only can approve</option>
                        <option value="1">Members can approve</option>
                    </select>
                </GroupAboutField>
                <GroupAboutField label={"Posting Permissions"}>
                    <select value={group.canMembersPost ? "1" : "0"} onChange={(e) => {
                        const val = e.target.value;
                        group.canMembersPost = val === "0" ? false : true;
                        this.setState((state, props) => { return { group } });

                    }}>
                        <option value="0">Admin only can post</option>
                        <option value="1">Members can post</option>
                    </select>
                </GroupAboutField>
                <GroupAboutField label={"Post Approval"}>
                    <select value={group.postApproval ? "0" : "1"} onChange={(e) => {
                        const val = e.target.value;
                        group.postApproval = val === "1" ? false : true;
                        this.setState((state, props) => { return { group } });

                    }}>
                        <option value="0">Admin approve</option>
                        <option value="1">Auto approve</option>
                    </select>
                </GroupAboutField>
                <div className="group-about-pane-actions">
                    <button className="group-about-pane-action-save" onClick={this.save.bind(this)}>Save</button>
                    <button className="group-about-pane-action-cancel" onClick={this.reset.bind(this)}>Reset</button>
                </div>
            </div>
        )
    }
}

const GroupAboutField = (props) => {
    return (
        <div className="group-about-pane-field">
            <span>{props.label}</span>
            <div>
                {props.children}
            </div>
        </div>
    )
}

const GroupAboutFieldInput = (props) => {
    return (
        <div className="group-about-pane-field-input">
            {props.children}
            {props.warning && <span className="warning-note">{props.warning}</span>}
        </div>
    )
}




// WEBPACK FOOTER //
// ./src/pages/Group.jsx